import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import Projeto from "features/projetos/models/Projeto";

async function updateProjeto(projeto: Projeto): Promise<IResponse<ValidationResult>> {
  return await axios.put(`/Projetos/${projeto.id}`, projeto);
}

export default updateProjeto;